
import React, { useEffect, useState } from 'react';
import './aboutus.css';

export default function AboutUs() {
  const [logoText, setLogoText] = useState('');
  const [apiData, setApiData] = useState(null);
  const [apiUrl, setApiUrl] = useState('');

  
  useEffect(() => {
    fetch('/templates/api.txt')
      .then((res) => res.text())
      .then((data) => {
        setApiUrl(data.trim());
      })
      .catch((err) => {
        console.error('Ошибка загрузки API URL:', err);
      });
  }, []);

  
  useEffect(() => {
    if (!apiUrl) return;
    fetch(`${apiUrl}api/info`)
      .then((res) => res.json())
      .then((data) => {
        setApiData(data);
        setLogoText(data.title || '');
      })
      .catch((err) => console.error('Ошибка загрузки /api/info:', err));
  }, [apiUrl]);

  return (
    <div className="aboutus-container">
      <div className="aboutus-header">
        <div className="aboutus-header-content">
          <h1 className="aboutus-heading">
            {logoText} — это магазин сигарет и лидер рынка на сегодняшний день
          </h1>
          <p className="aboutus-paragraph">
            Наш магазин возник из простой идеи — предложить ценителям сигарет только лучшее. Когда мы начинали, нас вдохновляла мысль создать место, где каждый покупатель найдет свой идеальный вкус. Мы тщательно отбираем продукцию, работая только с проверенными брендами, чтобы гарантировать высокое качество.
          </p>
        </div>
      </div>

      <div className="info-block-container">
        <div className="info-block">
          <div className="info-title">О магазине</div>
          <div>
            <p className="info-description">
              {logoText} — Наш магазин возник из простой идеи — предложить ценителям сигарет только лучшее. Когда мы начинали, нас вдохновляла мысль создать место, где каждый покупатель найдет свой идеальный вкус. Мы тщательно отбираем продукцию, работая только с проверенными брендами, чтобы гарантировать высокое качество.
            </p>
            <p className="info-description">
              Сегодня {logoText} — это просторный хьюмидор и более 1000 позиций сигарет из разных стран: от мировой классики до лимитированных и редких экземпляров.
            </p>
          </div>
        </div>

        <div className="info-block">
          <div className="info-title">Стандарты и качество</div>
          <div>
            <p className="info-description">
              Мы верим, что каждый покупатель заслуживает только лучшего, поэтому придерживаемся строгих стандартов качества:
            </p>
            <ul className="info-list">
              <li>
                <strong>Оригинальная продукция:</strong><br />Мы работаем только с официальными поставщиками и проверенными брендами, исключая любые риски подделок.
              </li>
              <li>
                <strong>Контроль качества:</strong><br />Каждая партия товаров проходит тщательную проверку, чтобы гарантировать свежесть и соответствие мировым стандартам.
              </li>
              <li>
                <strong>Честность и прозрачность:</strong><br />Мы предоставляем полную информацию о наших продуктах, чтобы вы могли сделать осознанный выбор.
              </li>
              <li>
                <strong>Комфорт для клиента:</strong> <br />Удобный сервис, быстрая доставка и лояльные цены делают нас надежным партнером для наших покупателей.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
